export function loadCookiebot() {
  const cbid = import.meta.env.VITE_COOKIEBOT_CBID
  if (!cbid) {
    return
  }
  const script = document.createElement('script')
  script.id = 'Cookiebot'
  script.src = 'https://consent.cookiebot.com/uc.js'
  script.setAttribute('data-cbid', cbid)
  script.setAttribute('data-blockingmode', 'auto')
  script.type = 'text/javascript'
  document.head.prepend(script)
}
